import { getServerSideContext } from 'frontend/utils/ssr-context';

export function getWindowLocation() {
  if (typeof window !== 'undefined') {
    return window.location;
  }
  const ctx = getServerSideContext();
  const sp = ctx.url.split('?');
  return {
    href: ctx.backend.response.base_url + ctx.url,
    pathname: sp[0],
    search: sp.length > 1 ? sp[1] : '',
  };
}
